export default __webpack_public_path__ + "static/intro_elements_A1_desktop-378ff0005d95f06d36432e68b3c48a0b.jpg";